import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@hortis/ui/hover-card";
import { type TaxonomicRank } from "generated/graphql";
import { type ReactNode } from "react";
import { taxonomicRankLabelMap } from "src/utils/label-maps/taxonomic-rank";

export const RankHoverCard = ({
  rank,
  scientificName,
  children,
}: {
  rank: TaxonomicRank;
  scientificName: string;
  children: ReactNode;
}) => {
  return (
    <HoverCard openDelay={300}>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent
        className="flex max-w-xs cursor-default flex-col gap-4 p-4"
        align="start"
      >
        <div className="space-y-0.5">
          <div className="text-sm font-medium text-grey-500">
            {taxonomicRankLabelMap[rank]}
          </div>
          <div className="font-medium text-grey-900">{scientificName}</div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};
